import axios from "axios";
import { loadProgressBar } from 'axios-progress-bar';
import 'axios-progress-bar/dist/nprogress.css';
let baseURL = "/"; //production
// baseURL = "https://www.motekhases.ir/"; //local

const baseURLForMetaTag = "https://www.motekhases.ir";
function setAuthToken(key = "1234") {
  APIClient.defaults.headers = { key: key, agent: "win" };
}

function LoginWithSMS(data) {
  return axios.post(`${baseURL}oneTimeLogin`, data);
}
const APIClient = axios.create({ baseURL,headers: {"Access-Control-Allow-Origin": "*"} });
loadProgressBar({},APIClient);

export { APIClient, setAuthToken, baseURL, baseURLForMetaTag, LoginWithSMS };
